import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Col, Row, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderTitle,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { useDispatch, useSelector } from "react-redux";
import {
  addItem,
  editItem,
  fetchDataAllCompany,
  fetchId,
  fetchIdNoloading,
  fetchUser,
  resetData,
  selectDataAllCompany,
  selectDataUser,
  selectId,
  selectLoading,
  uploadItem,
  uploadValidate,
} from "./userSlice";
import { useHistory, useParams } from "react-router";
import {
  showSuccessDialog,
  showErrorDialog,
  GOOGLE_KEY,
  allDay,
  getValueStatus,
  createChangeHandler,
  CallApi,
  checkEmptyFields,
  showDialog,
  paramsMasterAll,
  setOptionsMaster,
  paramsUserType,
  paramsONOFFType,
  paramsActiveType,
  paramsONOFF,
  statusFormatter,
  formatterStatus,
} from "../../utility";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { Marker } from "../../utility/Marker";
import GoogleMapReact from "google-map-react";
import Select from "react-select";
import { selectUser } from "../../modules/Auth/_redux/authRedux";
import CurrencyInput from "react-currency-input-field";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Mengimpor ikon dari react-icons

import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
import { fetchRole, selectRole } from "../role/roleSlice";
import MultiSelectAll from "../../utility/MultiSelectAll";
import { fetchBranch, selectBranch } from "../branch/branchSlice";
import { fetchParam, selectDataParam } from "../param/paramSlice";
import { fetchTemplate } from "../product/productSlice";

export const UserCreate = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const user = useSelector(selectUser);
  const dataId = useSelector(selectId);
  const dataRole = useSelector(selectRole);
  const dataBranch = useSelector(selectBranch);
  const dataCompany = useSelector(selectDataAllCompany);
  const dataParam = useSelector(selectDataParam);
  const dataUser = useSelector(selectDataUser);
  const ref = useRef();

  const { id } = useParams();

  const [name, setName] = useState("");
  const [username, setUsername] = useState("");
  const [reffUser, setReffUser] = useState("");
  const [supervisor, setSupervisor] = useState("");
  const [company, setCompany] = useState([]);
  const [password, setPassword] = useState("");
  const [passwordAcc, setPasswordAcc] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [roleName, setRoleName] = useState("");
  const [type, setType] = useState("");
  const [sync, setSync] = useState("");
  const [status, setStatus] = useState(true);
  const [branch, setBranch] = useState("");
  const [ownerships, setOwnerships] = useState([]);

  const [showPassword, setShowPassword] = useState(false);
  const [optionsRole, setOptionRole] = useState([]);
  const [optionsType, setOptionType] = useState([]);
  const [optionsBranch, setOptionBranch] = useState([]);
  const [optionsSupervisor, setOptionSupervisor] = useState([]);

  const paramsId = {
    user_id: id,
  };

  useEffect(() => {
    async function fetchMyAPI() {
      await dispatch(resetData());
      if (id !== undefined) {
        await CallApi(paramsId, fetchId, dispatch);
      }

      await dispatch(fetchRole({ ...paramsMasterAll }));
      await dispatch(fetchBranch({ ...paramsMasterAll }));
      await dispatch(
        fetchUser({ ...paramsMasterAll, roles: "COMPANY_SUPERVISOR" })
      );
      await dispatch(
        fetchParam({
          ...paramsMasterAll,
          param_group_code: "SALES_TYPE",
          is_active: true,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataRole.length > 0) {
      setOptionsMaster(dataRole, setOptionRole, "role_id", "role_name");
    }
  }, [dataRole]);

  useEffect(() => {
    if (dataParam.length > 0) {
      setOptionsMaster(dataParam, setOptionType, "param_code", "param_value");
    }
  }, [dataParam]);

  useEffect(() => {
    if (dataUser.length > 0) {
      setOptionsMaster(
        dataUser,
        setOptionSupervisor,
        "user_id",
        "name_username"
      );
    }
  }, [dataUser]);

  useEffect(() => {
    if (user && user.list_data_ownerships.length > 0) {
      setOptionsMaster(
        user.list_data_ownerships,
        setOptionBranch,
        "branch_code",
        "branch_name"
      );
    }
  }, [user]);

  useEffect(() => {
    if (dataId) {
      setName(dataId?.name);
      setUsername(dataId?.username);
      setReffUser(dataId?.reff_sales_id);
      setEmail(dataId?.email);
      setRole(dataId?.role_id);
      setRoleName(dataId?.roles);
      setType(dataId?.sales_type);
      setBranch(dataId?.branch_code);
      setSync(dataId?.available_direct_sync);
      setStatus(dataId?.is_active);
      setSupervisor(dataId?.supervisor_id);
      setCompany(dataId?.user_companies?.map((item) => item.company_id));
      setOwnerships(
        dataId?.list_data_ownerships?.map((item) => item.branch_code)
      );
    }
  }, [dataId]);

  const handleSave = async () => {
    const fields = [
      { value: name, message: "input Name", valid: true },
      { value: username, message: "input Username", valid: true },
      { value: role, message: "input Role", valid: true },
    ];

    const errorMessage = checkEmptyFields(fields);
    if (errorMessage) {
      return showDialog(errorMessage);
    }
    if (roleName === "Company Sales" && type === "") {
      return showDialog("Please input user Type");
    }

    if (roleName === "Company Sales" && sync === "") {
      return showDialog("Please input Direct Sync");
    }

    const params = {
      name: name,
      user_id: id,
      username: username,
      password: password,
      password_confirmation: passwordAcc,
      email: email,
      role_id: role,
      sales_type: type,
      branch_code: branch,
      company_id: id === undefined ? user.company_id : dataId.company_id,
      is_active: status,
      available_direct_sync: sync,
      supervisor_id: supervisor,
      reff_sales_id: reffUser,
      user_companies: company?.map((item) => {
        return {
          company_id: item,
        };
      }),
      list_data_ownerships: ownerships?.map((item) => {
        return {
          branch_code: item,
        };
      }),
    };

    try {
      const response =
        id === undefined
          ? await dispatch(addItem(params))
          : await dispatch(editItem(params));
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.message);
        (await id) === undefined
          ? history.goBack()
          : await CallApi(paramsId, fetchIdNoloading, dispatch);
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  const handleChangeRole = async (e) => {
    console.log(e, "e");
    if (e === null) {
      e = undefined;
      setRole("");
      setRoleName("");
      setUsername("");
    } else {
      setRole(e.value);
      setRoleName(e.label);
      if (e.label === "Company Sales") {
        setUsername(user?.next_sls_code);
      } else if (e.label === "Company Administrator") {
        setUsername(user?.next_adm_code);
      } else if (e.value === "Head Office Administrator") {
        setUsername(user?.next_ho_code);
      } else if (e.value === "Company Supervisor") {
        setUsername(user?.next_spv_code);
      }
    }
  };

  const handleChangeType = createChangeHandler(setType);
  const handleChangeBranch = createChangeHandler(setBranch);
  const handleChangeSynch = createChangeHandler(setSync);
  const handleChangeSupervisor = createChangeHandler(setSupervisor);
  const handleChangeStatus = createChangeHandler(setStatus);

  const options =
    id === undefined
      ? user.user_companies
          .filter((item) => item.company_id !== user.company_id)
          .map((item) => ({
            label: item.company_name,
            value: item.company_id,
          }))
      : user.user_companies.map((item) => ({
          label: item.company_name,
          value: item.company_id,
        }));

  function getValueOptions(data) {
    let output = [];
    data.map((val) => {
      const result = options.filter((data) => val === data.value);
      output.push(result[0]);
    });
    return output;
  }

  function getValueOptionsOwnerships(data) {
    let output = [];
    data.map((val) => {
      const result = optionsBranch.filter((data) => val === data.value);
      output.push(result[0]);
    });
    return output;
  }

  const handleCompanyChange = (selectedOptions) => {
    if (selectedOptions) {
      setCompany(
        selectedOptions.map(function(selectedOptions) {
          if (selectedOptions) {
            return selectedOptions["value"];
          }
        })
      );
    } else {
      setCompany([]);
    }
  };
  const handleOwnershipsChange = (selectedOptions) => {
    if (selectedOptions) {
      setOwnerships(
        selectedOptions.map(function(selectedOptions) {
          if (selectedOptions) {
            return selectedOptions["value"];
          }
        })
      );
    } else {
      setOwnerships([]);
    }
  };

  // upload

  const [showUpload, setShowUpload] = useState(false);
  const [fileUpload, setFileUpload] = useState(null);
  const [tableUpload, setTableUpload] = useState([]);

  const handleShowUpload = (data) => {
    setShowUpload(true);
  };

  const handleCloseUpload = () => {
    setTableUpload([]);
    setShowUpload(false);
  };

  const handleUpload = async () => {
    const params = tableUpload.filter(
      (entry) => entry.status_validation === "Success"
    );

    if (params.length === 0) {
      return showDialog("Please upload data first");
    }

    try {
      const response = await dispatch(uploadItem(params));
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.message);
        (await id) === undefined
          ? history.goBack()
          : await CallApi(paramsId, fetchIdNoloading, dispatch);
        handleCloseUpload();
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFileUpload(selectedFile);
    validateFile(selectedFile);
  };

  const validateFile = async (file) => {
    if (file) {
      try {
        const response = await dispatch(uploadValidate(file));
        console.log(response, "response");
        if (response.payload.status === 200) {
          const initData = response.payload.data.data.map((item, index) => {
            return {
              ...item,
              no: index + 1,
            };
          });
          setTableUpload(initData);
        } else {
          showErrorDialog(response.payload.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
        console.log(error.message);
      }
    } else {
      console.log("No file uploaded");
    }
  };

  const handleDownload = async () => {
    const params = {
      file_type: "USER",
    };
    try {
      const response = await dispatch(fetchTemplate(params));
      if (response.payload.status === 200) {
        const blob = new Blob([response.payload.data], {
          type: "application/xlsx",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "USER.xlsx";
        link.click();
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const columns = [
    {
      text: "No",
      dataField: "no",
      style: { minWidth: "60px" },
    },

    {
      text: "sales / admin",
      dataField: "company_sales_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: (cell, row) => {
        return (
          <div>
            <span>
              <b>{row.company_sales_code}</b>
            </span>
            <br />
            <span>{row.name}</span>
          </div>
        );
      },
    },

    {
      text: "branch",
      dataField: "branch_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "ownerships",
      dataField: "ownerships",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "sales type",
      dataField: "sales_type_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "status active",
      dataField: "is_active",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: statusFormatter,
    },

    {
      text: "roles",
      dataField: "roles",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "Direct Sync",
      dataField: "available_direct_sync",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },

    {
      text: "status",
      dataField: "status_validation",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatterStatus,
    },
    {
      text: "message",
      dataField: "message_validation",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
  ];

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader>
          <CardHeaderTitle className="card-title">
            {id === undefined ? "Create User" : "Edit User"}
          </CardHeaderTitle>
          <CardHeaderToolbar>
            <Button
              className="btn btn-secondary mr-3"
              onClick={() => history.goBack()}
            >
              <i className="fa fa-arrow-left"></i>Back
            </Button>
            {id === undefined && (
              <Button
                className="btn btn-warning mr-3"
                onClick={handleShowUpload}
              >
                Upload
              </Button>
            )}

            <Button
              className="btn btn-danger"
              onClick={(e) => {
                handleSave();
              }}
            >
              Save
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Company</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      value={
                        id === undefined
                          ? user.company_name
                          : dataId?.company_name
                      }
                      disabled
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      Role <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      options={optionsRole}
                      value={getValueStatus(role, optionsRole)}
                      placeholder="Select ..."
                      onChange={handleChangeRole}
                      isClearable={true}
                      isDisabled={id !== undefined ? true : false}
                      // isDisabled={
                      //   id !== undefined && user?.roles[0] !== "Super Admin"
                      //     ? true
                      //     : false
                      // }
                    />
                  </Col>
                </Form.Group>

                {(roleName === "Company Sales" ||
                  roleName === "Company Supervisor") && (
                  <>
                    <Form.Group as={Row}>
                      <Form.Label column sm={3}>
                        <b>
                          Type <b className="color-red">*</b>
                        </b>
                      </Form.Label>
                      <Col sm={6}>
                        <Select
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          options={optionsType}
                          value={getValueStatus(type, optionsType)}
                          placeholder="Select ..."
                          onChange={handleChangeType}
                          isClearable={true}
                        />
                      </Col>
                    </Form.Group>
                  </>
                )}

                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      Username <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      onChange={(e) => setUsername(e.target.value)}
                      value={username}
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Reff User</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      onChange={(e) => setReffUser(e.target.value)}
                      value={reffUser}
                    />
                  </Col>
                </Form.Group>

                {roleName === "Company Sales" && (
                  <>
                    <Form.Group as={Row}>
                      <Form.Label column sm={3}>
                        <b>Supervisor</b>
                      </Form.Label>
                      <Col sm={6}>
                        <Select
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          options={optionsSupervisor}
                          value={getValueStatus(supervisor, optionsSupervisor)}
                          placeholder="Select ..."
                          onChange={handleChangeSupervisor}
                          isClearable={true}
                        />
                      </Col>
                    </Form.Group>
                  </>
                )}
              </Col>
              {/* Right Row */}

              <Col sm={6}>
                {(roleName === "Company Sales" ||
                  roleName === "Company Supervisor") && (
                  <>
                    <Form.Group as={Row}>
                      <Form.Label column sm={3}>
                        <b>Branch</b>
                      </Form.Label>
                      <Col sm={6}>
                        <Select
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          options={optionsBranch}
                          value={getValueStatus(branch, optionsBranch)}
                          placeholder="Select ..."
                          onChange={handleChangeBranch}
                          isClearable={true}
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row}>
                      <Form.Label column sm={3}>
                        <b>
                          Direct Sync <b className="color-red">*</b>
                        </b>
                      </Form.Label>
                      <Col sm={6}>
                        <Select
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          options={paramsONOFF}
                          value={getValueStatus(sync, paramsONOFF)}
                          placeholder="Select ..."
                          onChange={handleChangeSynch}
                          isClearable={true}
                        />
                      </Col>
                    </Form.Group>
                  </>
                )}

                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      Name <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      onChange={(e) => setName(e.target.value)}
                      value={name}
                    />{" "}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Email</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      onChange={(e) => setEmail(e.target.value)}
                      value={email}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Status</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      options={paramsActiveType}
                      value={getValueStatus(status, paramsActiveType)}
                      placeholder="Select ..."
                      onChange={handleChangeStatus}
                      isClearable={true}
                      isDisabled={id === undefined ? true : false}
                    />
                  </Col>
                </Form.Group>
                {(user?.roles[0] === "Super Admin" ||
                  user?.roles[0] === "PRINCIPAL_ADMIN") &&
                  (roleName === "Company Administrator" ||
                    roleName === "Principal Administrator" ||
                    roleName === "Head Office Administrator") && (
                    <Form.Group as={Row}>
                      <Form.Label column sm={3}>
                        <b>Add Company</b>
                      </Form.Label>
                      <Col sm={6}>
                        <MultiSelectAll
                          options={options}
                          value={getValueOptions(company)}
                          onChange={handleCompanyChange}
                          placeholder="Select Company..."
                        />
                      </Col>
                    </Form.Group>
                  )}
                {user?.roles[0] === "Super Admin" &&
                  (roleName === "Company Administrator" ||
                    roleName === "Head Office Administrator") && (
                    <Form.Group as={Row}>
                      <Form.Label column sm={3}>
                        <b>Ownerships</b>
                      </Form.Label>
                      <Col sm={6}>
                        <MultiSelectAll
                          options={optionsBranch}
                          value={getValueOptionsOwnerships(ownerships)}
                          onChange={handleOwnershipsChange}
                          placeholder="Select Ownerships..."
                        />
                      </Col>
                    </Form.Group>
                  )}
              </Col>
            </Form.Group>
          </Form>
        </CardBody>
      </Card>

      <Modal
        show={showUpload}
        onHide={handleCloseUpload}
        size="lg"
        dialogClassName="modal-70"
      >
        <Modal.Header closeButton>
          <Modal.Title>Upload User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>
                    File <b className="color-red">*</b>
                  </b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    ref={ref}
                    type="file"
                    label="Input "
                    onChange={handleFileChange}
                    custom
                    accept=".xlsx"
                  />
                </Col>
              </Form.Group>
            </Col>
            <Col sm={6}>
              <Button variant="warning" onClick={() => handleDownload()}>
                Download Template
              </Button>
            </Col>
          </Form.Group>

          {tableUpload.length > 0 && (
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden rounded mt-5"
              bootstrap4
              keyField="no"
              data={tableUpload}
              columns={columns}
              hover
              striped
            ></BootstrapTable>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseUpload()}>
            Close
          </Button>
          <Button variant="danger" onClick={handleUpload}>
            Save
          </Button>{" "}
        </Modal.Footer>
      </Modal>
    </>
  );
};
